import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { navLinks } from "../mock";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer data-testid="site-footer" className="bg-[#0e0e10] text-white">
      {/* Marquee */}
      <div className="overflow-hidden border-y border-white/10 py-6">
        <div data-testid="footer-marquee-track" className="flex w-max whitespace-nowrap animate-marquee">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} aria-hidden={i === 1} className="flex shrink-0 items-center">
              {t("footer.words", { returnObjects: true }).map((word, index) => (
                <span key={index} data-testid={`footer-marquee-word-${i}-${index}`} className="font-display text-3xl md:text-5xl font-semibold tracking-tight mx-6 text-white/70">
                  {word} <span data-testid={`footer-marquee-divider-${i}-${index}`} className="text-[#0057FF]">/</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-5" data-testid="footer-logo">
              <svg width="26" height="26" viewBox="-3 0 28 28" className="shrink-0 text-[#0057FF]" aria-hidden="true" data-testid="footer-logo-mark">
                <path d="M20 5.5 A12 12 0 1 0 20 22.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                <circle cx="21.5" cy="14" r="2.4" fill="currentColor" />
              </svg>
              <span className="font-display font-extrabold tracking-[0.18em] text-lg" data-testid="footer-logo-name">ORICO</span>
            </div>
            <p data-testid="footer-description" className="text-white/55 text-sm max-w-sm leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 data-testid="footer-navigation-heading" className="text-[11px] uppercase tracking-[0.16em] text-white/40 mb-5">{t("footer.navigation")}</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} data-testid={`footer-nav-${l.key}`} className="text-sm text-white/75 hover:text-white link-underline">{t(`nav.${l.key}`)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 data-testid="footer-contact-heading" className="text-[11px] uppercase tracking-[0.16em] text-white/40 mb-5">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li data-testid="footer-address">Jurišićeva 19, 10000 Zagreb</li>
              <li data-testid="footer-email">trendiarh@gmail.com</li>
              <li data-testid="footer-phone-primary">091 5400 194</li>
              <li data-testid="footer-phone-secondary">091 183 2002</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.12em] text-white/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} ORICO. {t("footer.rights")}</span>
          <div className="flex gap-6">
            <a href="#" data-testid="footer-instagram-link" className="hover:text-white flex items-center gap-1 group">Instagram <ArrowUpRight size={13} className="hover-arrow" /></a>
            <a href="#" data-testid="footer-linkedin-link" className="hover:text-white flex items-center gap-1 group">LinkedIn <ArrowUpRight size={13} className="hover-arrow" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
